import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {AnalyticsListenerConfig, AnalyticsListener} from "./analytics_listener"

export const analyticsListenerLoader = function (options = {}) {
    componentLoader(componentConfig(AnalyticsListener, AnalyticsListenerConfig.componentTypeKey, AnalyticsListenerConfig.baseHtmlClass), options);
};

